import store from '../../../../../resources/js/store'

export default function () {
  if (store.state.module === 'context') {
    store.dispatch('manager/fetch', 'context')
  }
}
